export default {
    "title": "Extranet Administration Panel / Documentation",
    "nameCollection": "Documents",
    "description": "List of documents",
    "name": "Document name ",
    "clientName": "Client name",
    "totalDocumentation": "Total documents: <0>{{count}}</0>",
    "download": "Download",
    "client": "Client",
    "startDate": "Start date ",
    "endDate": "Expiration date ",
    "fromStartDate": "From start date ",
    "toStartDate": "To start date ",
    "fromEndDate": "From expiration date ",
    "toEndDate": "To expiration date ",
    "type": "Type",
    "size": "Size"
}